// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `Базовые настройки
.page-wrapper {
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 100vh;
  background-color: #f0f4f0;
  padding: 15px;
  font-family: 'Montserrat', sans-serif;
}

.form-container {
  display: flex;
  width: 100%;
  max-width: 1000px;
  min-height: 600px; /* Фиксированная высота для десктопа */
  background: white;
  border-radius: 20px;
  overflow: hidden;
  box-shadow: 0 20px 40px rgba(0,0,0,0.05);
}
.step-container{
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
/* Левая панель */
.sidebar {
  width: 320px;
  background-color: #becdef;
  padding: 40px;
  display: flex;
  flex-direction: column;
  border-right: 1px solid #e0e0e0;
}

.sidebar-top {
  display: flex;
  align-items: center;
  gap: 15px;
  margin-bottom: 30px;
}

.logo-circle {
  width: 45px;
  height: 45px;
  background: black;
  color: #2563eb;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 700;
  font-size: 24px;
}

.brand-name { font-weight: 700; font-size: 16px; float: left; }
.brand-phone { color: #2563eb; font-size: 13px; font-weight: 600; }
.sidebar-text { line-height: 1.6; color: #333; font-size: 14px; }
.sidebar-footer { margin-top: auto; font-size: 12px; color: #888; line-height: 1.4; }

/* Правая панель */
.main-content {
  flex: 1 1;
  padding: 50px;
  /* position: relative; */
  display: flex;
  flex-direction: column;
}

.progress-bar {
  position: absolute;
  top: 0; left: 0; right: 0;
  height: 5px;
  background: #f0f0f0;
}

.progress-fill {
  height: 100%;
  background: #1aa053;
  transition: width 0.4s ease;
}

/* Стили полей ввода */
.form-inner { width: 100%; }
.form-title { font-size: 24px; font-weight: 600; margin-bottom: 35px; }

.input-group {
  margin-bottom: 25px;
  width: 100%;
}

.input-group label {
  display: block;
  margin-bottom: 10px;
  font-size: 14px;
  color: #1c1c1c;
}

/* ЧТОБЫ СТИЛИ ПРИМЕНЯЛИСЬ: используйте этот класс */
.input-field {
  width: 100%; /* Делает инпут длинным */
  padding: 16px 20px;
  border: 1px solid #e0e0e0;
  border-radius: 8px;
  font-size: 15px;
  outline: none;
  transition: all 0.2s;
  box-sizing: border-box; /* Важно для padding */
}

.input-field:focus {
  border-color: #1aa053;
  box-shadow: 0 0 0 3px rgba(26, 160, 83, 0.05);
}

.input-field.error { border-color: #ff4d4d; background: #fff8f8; }

/* Кнопки */
.form-footer {
  margin-top: auto;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-top: 30px;
}

.btn-next {
  background: #2563eb;
  color: white;
  padding: 12px 30px;
  border-radius: 8px;
  border: none;
  font-weight: 600;
  cursor: pointer;
}

.back-btn-sq {
  width: 45px;
  height: 45px;
  border: 1px solid #e0e0e0;
  background: white;
  border-radius: 8px;
  cursor: pointer;
}

@media (max-width: 768px) {
  /* Делаем общий фон страницы и контейнера одним цветом для слияния */
  .page-wrapper {
    background-color: #f4f7f4; /* Светло-зеленоватый фон как на макете */
    padding: 0;
    min-height: auto;
    display: flex;
    justify-content: center;
  }
.progress-bar {
  position: absolute;
  top: 20px; left: 0; right: 0;
  height: 5px;
  background: #f0f0f0;
}
.form-title { font-size: 24px; margin-top: 20px; font-weight: 600; margin-bottom: 25px; }

.sidebar-top {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 15px;
  margin-bottom: 0px;
}
/* Кнопки */
.form-footer {
  margin-top: 0;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-top: 30px;
}
.input-group {
  margin-bottom: 15px;
  width: 100%;
}

  .form-container {
    flex-direction: column;
    box-shadow: none; /* Убираем тень, чтобы блок сливался с фоном */
    background-color: transparent; /* Прозрачный фон для контейнера */
    gap: 0;
    max-width: 350px;
  }

  /* Объединяем боковую панель и основной контент */
  .sidebar, .main-content {
    width: 100%;
    background-color: #f4f7f4; /* Тот же цвет, что и у всего блока */
    border: none;
    padding: 20px;
  }

  .sidebar {
    padding-bottom: 0; /* Уменьшаем отступ снизу у сайдбара */
  }

  /* Делаем разделительную линию очень тонкой или убираем её */
  .sidebar-content {
    border-bottom: 0px dashed rgba(0,0,0,0.1);
    padding: 0;
  }

  .main-content {
    padding-top: 10px;
  }

  /* Адаптация кнопок загрузки (Step 2) */
  .upload-container-main {
    flex-direction: column;
    gap: 15px;
  }

  .btn-upload-action {
    width: 100%; /* Кнопки загрузки на всю ширину для удобства */
  }
  .form-inner {
    padding: 10px 0;
    min-height: 0;
    height: auto;
  }
  /* Навигация внизу */
  .form-footer-right {
    flex-direction: column-reverse;
    gap: 20px;
    background-color: #f4f7f4;
    padding: 20px 0;
  }

  .nav-buttons-group {
    width: 100%;
    display: flex;
    justify-content: space-between;
    gap: 10px;
  }

  .btn-back-white, .btn-next-main {
    flex: 1 1; /* Кнопки делят место поровну */
    text-align: center;
    justify-content: center;
  }
}

/* Совсем маленькие экраны (телефоны) */
@media (max-width: 480px) {
  .page-wrapper {
    padding: 0;
  }
  
  .form-inner {
    padding: 10px 0;
  }
}





.form-inner {
  display: flex;
  flex-direction: column;
  height: 100%;
  min-height: 350px; 
}

/* Сетка загрузки */
.upload-container-main {
  display: flex;
  gap: 20px;
  margin-top: 20px;
}

.upload-item-box {
  flex: 1 1;
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.upload-label {
  font-size: 14px;
  font-weight: 600;
  color: #333;
}

/* Кнопка "📥 Загрузить" как на втором скрине */
.btn-upload-action {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  background-color: #2563eb; /* Глубокий зеленый */
  color: white;
  padding: 14px;
  border-radius: 10px;
  cursor: pointer;
  font-weight: 600;
  font-size: 15px;
  transition: 0.2s;
}

.btn-upload-action:hover {
  background-color: #244faa;
}

/* Нижняя панель навигации */
.form-footer-right {
  margin-top: auto; /* Толкает футер вниз */
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-top: 30px;
}

.nav-buttons-group {
  display: flex;
  gap: 15px;
}

/* Кнопка Назад (белая) */
.btn-back-white {
  padding: 12px 25px;
  background: white;
  border: 1px solid #e0e0e0;
  border-radius: 12px;
  color: #444;
  font-weight: 500;
  cursor: pointer;
}

/* Кнопка Далее (зеленая) */
.btn-next-main {
  padding: 12px 30px;
  background-color: #2563eb;
  color: white;
  border: none;
  border-radius: 8px;
  font-weight: 600;
  cursor: pointer;
  transition: background 0.2s;
}

.btn-next-main:hover {
  background-color: #2563eb;;
}

.file-ready-badge {
  font-size: 12px;
  color: #2563eb;
  background: #b5cbf9;
  padding: 8px 12px;
  border-radius: 6px;
  border: 1px dashed #2563eb;
}

.error-hint {
  color: #d32f2f;
  font-size: 12px;
  font-weight: 500;
}

/* Адаптивность для мобильных */
@media (max-width: 600px) {
  .upload-container-main {
    flex-direction: column;
  }
  .form-footer-right {
    flex-direction: column;
    gap: 20px;
    align-items: flex-end; /* Кнопки всё равно останутся справа */
  }
}






/* Левая информационная карточка */
.left-card {
  background: linear-gradient(135deg, #1e293b 0%, #0f172a 100%);
  padding: 40px;
  border-radius: 24px 0 0 24px;
  width: 350px;
  min-height: 500px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  border: 1px solid rgba(255, 255, 255, 0.05);
  box-shadow: -10px 0 30px rgba(0, 0, 0, 0.2);
}

.left-logo .logo-circle {
  width: 60px;
  height: 60px;
  background: linear-gradient(45deg, #42b693, #60e9bf);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 24px;
  box-shadow: 0 0 20px rgba(66, 182, 147, 0.4);
}

.logo-text {
  font-size: 28px;
  font-weight: 800;
  color: #0f172a;
}

.left-title {
  font-size: 28px;
  margin-bottom: 8px;
  background: linear-gradient(90deg, #fff, #94a3b8);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
}

.left-phone {
  color: #42b693;
  font-weight: 600;
  margin-bottom: 16px;
}

.left-desc {
  color: #94a3b8;
  line-height: 1.6;
  font-size: 15px;
}

/* Правый блок с формой */
.right-block {
  background: #ffffff;
  /* padding: 40px; */
  border-radius: 0 24px 24px 0;
  max-width: 450px;
  min-height: 500px;
  display: flex;
  flex-direction: column;
  /* box-shadow: 10px 0 30px rgba(0, 0, 0, 0.1); */
}

.step-title {
  color: #0f1720;
  font-size: 24px;
  font-weight: 700;
  margin-bottom: 30px;
  text-align: center;
}

/* Стили полей ввода */
.input-group {
  margin-bottom: 20px;
  display: flex;
  flex-direction: column;
}

.input-group label {
  font-size: 14px;
  font-weight: 600;
  color: #64748b;
  margin-bottom: 8px;
}

.input-group input {
  padding: 14px 16px;
  border: 2px solid #f1f5f9;
  border-radius: 12px;
  font-size: 16px;
  transition: all 0.3s ease;
  outline: none;
}

.input-group input:focus {
  border-color: #42b693;
  background: #f8fafc;
  box-shadow: 0 0 0 4px rgba(66, 182, 147, 0.1);
}

.input-error {
  border-color: #ef4444 !important;
}

.error-text {
  color: #ef4444;
  font-size: 12px;
  margin-top: 5px;
}

/* Кнопки и нижний ряд */
.bottom-row {
  margin-top: auto;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding-top: 20px;
}

.back-btn {
  background: none;
  border: none;
  color: #94a3b8;
  font-weight: 600;
  cursor: pointer;
  transition: color 0.3s;
}

.back-btn:hover {
  color: #0f172a;
}

.next-btn {
  background: #42b693;
  color: white;
  border: none;
  padding: 12px 30px;
  border-radius: 12px;
  font-weight: 700;
  cursor: pointer;
  transition: all 0.3s ease;
  box-shadow: 0 4px 12px rgba(66, 182, 147, 0.3);
}

.next-btn:hover {
  background: #369c7d;
  transform: translateY(-2px);
  box-shadow: 0 6px 15px rgba(66, 182, 147, 0.4);
}

.step-counter {
  font-size: 14px;
  color: #cbd5e1;
  font-weight: 500;
}

/* Модальное окно */
.modal-overlay {
  position: fixed;
  inset: 0;
  background: rgba(15, 23, 42, 0.8);
  backdrop-filter: blur(8px);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
  animation: fadeIn 0.3s ease;
}

.modal-content {
  background: white;
  padding: 40px;
  border-radius: 24px;
  text-align: center;
  width: 90%;
  max-width: 400px;
  box-shadow: 0 20px 50px rgba(0,0,0,0.3);
}

.modal-icon {
  font-size: 50px;
  margin-bottom: 20px;
}

.modal-title {
  color: #0f172a;
  margin-bottom: 10px;
}

.modal-message {
  color: #64748b;
  margin-bottom: 25px;
}

.modal-close-btn {
  background: #0f172a;
  color: white;
  border: none;
  padding: 12px 25px;
  border-radius: 10px;
  cursor: pointer;
}

/* --- Адаптивность --- */
@media (max-width: 850px) {
  .form-page {
    flex-direction: column;
    padding: 10px;
  }
  
  .left-card {
    width: 100%;
    max-width: 450px;
    border-radius: 24px 24px 0 0;
    min-height: auto;
    padding: 30px;
  }

  .right-block {
    width: 100%;
    max-width: 380px;
    min-height: 0;
    border-radius: 0 0 24px 24px;
    padding: 0px;
  }
}

@keyframes fadeIn {
  from { opacity: 0; transform: scale(0.95); }
  to { opacity: 1; transform: scale(1); }
}







@media (max-width: 768px) {
  /* Общий фон страницы */
  .page-wrapper {
    background-color: #f4f7f4;
    padding: 10px;
    /* min-height: 100vh; */
    display: block; /* Снимаем центрирование flex для более естественного скролла */
  }

  .form-container {
    flex-direction: column;
    box-shadow: none;
    background-color: transparent;
    min-height: 400PX;
    
  }

  /* Верхняя часть (Сайдбар) */
  .sidebar {
    width: 100%;
    background-color: transparent;
    padding: 20px 10px 10px 10px; /* Аккуратные отступы */
    border: none;
    align-items: flex-start; /* Выравнивание по левому краю */
  }

  .sidebar-top {
    /* justify-content: flex-start; Лого не по центру */
    margin-bottom: 0px;
    width: 100%;
  }

  .sidebar-text {
    font-size: 14px;
    text-align: center;
    padding-bottom: 15px;
    border-bottom: 1px dashed rgba(0,0,0,0.1);
  }

  /* Основной контент */
  .main-content {
    width: 100%;
    padding: 10px;
    background-color: transparent;
  }

  .form-title {
    font-size: 22px;
    margin-top: 10px;
    margin-bottom: 25px;
    text-align: center;
  }

  /* Инпуты */
  .input-field {
    padding: 14px;
    font-size: 16px; /* Предотвращает зум на iOS */
  }

  /* Нижняя панель с кнопкой и шагом */
  .form-footer-right {
    margin-top: 3px;
    display: flex;
    flex-direction: column;
    position: relative; /* Для абсолютного позиционирования шага */
    padding-bottom: 4px; /* Место для текста шага */
  }

  .nav-buttons-group {
    display: flex;
    flex-direction: column;
    justify-self: center;
    width: 100%;
  }

  .btn-next-main {
    width: 100%; /* Кнопка на всю ширину */
    padding: 16px;
    font-size: 16px;
    display: flex;
    justify-content: center;
    border-radius: 12px;
  }

  .step-text {
    position: absolute;
    right: 0;
    left: 0;
    bottom: -18px;
    font-size: 13px;
    color: #888;
    font-weight: 600;
  }

  /* Убираем лишние элементы если они есть */
  .sidebar-footer, .progress-bar {
    display: none;
  }
}






/* --- Специальная адаптация для смартфонов (iPhone 11, 14 Pro, Android) --- */
@media (max-width: 480px) {
  /* 1. Общий фон и отступы */
  .page-wrapper {
    background-color: #f4f7f4; /* Светлый фон как в макете */
    padding: 0;
    display: block; /* Скролл становится естественным */
    overflow-x: hidden;
  }

  .form-container {
    width: 100%;
    min-height: auto;
    display: flex;
    flex-direction: column;
    box-shadow: none;
    padding-right: 12px;
    background: transparent;
  }

  /* 2. Верхняя часть (Логотип и информация) */
  .sidebar {
    width: 100%;
    padding: 25px 20px 10px;
    background: transparent;
    border: none;
  }

  .sidebar-top {
    justify-content: center; /* Лого по центру для мобильных */
    margin-bottom: 15px;
  }

  .sidebar-text {
    text-align: center;
    font-size: 13px;
    color: #555;
    padding: 0 10px 11px 20px;
    border-bottom: 1px dashed rgba(0,0,0,0.1);
    line-height: 1.4;
  }

  /* 3. Основная область формы */
  .main-content {
    padding: 10px;
    flex: none; /* Даем контенту расти свободно */
  }

  .form-title {
    font-size: 20px;
    margin: 10px 0 25px;
    text-align: center;
    color: #1a1a1a;
  }

  .form-inner {
    min-height: auto;
    width: 100%;
  }

  /* 4. Поля ввода - делаем "Touch Friendly" */
  .input-group {
    margin-bottom: 20px;
        align-self: center;

  }

  .input-field, .input-group input {
    height: 56px; /* Высокий инпут для удобства нажатия */
    font-size: 16px !important; /* ВАЖНО: 16px предотвращает авто-зум в Safari на iPhone */
    border-radius: 12px;
    padding: 0 16px;
  }

  /* 5. Загрузка документов (Step 2) */
  .upload-container-main {
    flex-direction: column;
    gap: 15px;
    margin-top: 10px;
  }

  .upload-item-box {
    width: 100%;
  }

  .btn-upload-action {
    height: 24px;
    font-size: 16px;
    border-radius: 12px;
    width: 90%;
  }

  /* 6. Нижняя панель навигации (Кнопки) */
  .form-footer-right, .form-footer, .bottom-row {
    padding: 20px;
    background: #f4f7f4;
    position: sticky; /* Кнопки всегда "под рукой" при скролле */
    bottom: 0;
    margin-top: 20px;
    border-top: 1px solid rgba(0,0,0,0.05);
    flex-direction: column !important; /* Кнопки друг под другом */
    gap: 12px;
  }

  .nav-buttons-group {
    width: 100%;
    flex-direction: column-reverse; /* Назад внизу, Далее вверху */
    gap: 10px;
  }

  .btn-next-main, .next-btn, .btn-next {
    width: 100%;
    height: 56px;
    font-size: 17px;
    font-weight: 700;
    border-radius: 14px;
    display: flex;
    align-items: center;
    justify-content: center;
    order: 1; /* Кнопка "Далее" выше */
  }

  .btn-back-white, .back-btn, .back-btn-sq {
    width: 100%;
    height: 50px;
    background: transparent;
    border: 1px solid #d0d0d0;
    color: #777;
    order: 2; /* Кнопка "Назад" ниже */
  }

  /* 7. Текст шагов (1 из 2) */
  .step-counter, .step-text {
    position: static;
    text-align: center;
    margin-top: 10px;
    font-size: 12px;
    color: #aaa;
    order: 3;
  }

  /* Прячем лишние декоративные элементы */
  .progress-bar, .sidebar-footer, .sidebar-bottom {
    display: none !important;
  }
}

/* Фикс для iPhone с челкой (Safe Area) */
@supports (padding: env(safe-area-inset-bottom)) {
  .form-footer-right, .form-footer {
    padding-bottom: calc(20px + env(safe-area-inset-bottom));
  }
}













`, "",{"version":3,"sources":["webpack://./src/style/ContactForm.css"],"names":[],"mappings":"AAAA;;EAEE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,iBAAiB;EACjB,yBAAyB;EACzB,aAAa;EACb,qCAAqC;AACvC;;AAEA;EACE,aAAa;EACb,WAAW;EACX,iBAAiB;EACjB,iBAAiB,EAAE,sCAAsC;EACzD,iBAAiB;EACjB,mBAAmB;EACnB,gBAAgB;EAChB,wCAAwC;AAC1C;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;AACrB;AACA,iBAAiB;AACjB;EACE,YAAY;EACZ,yBAAyB;EACzB,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,+BAA+B;AACjC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,cAAc;EACd,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;EAChB,eAAe;AACjB;;AAEA,cAAc,gBAAgB,EAAE,eAAe,EAAE,WAAW,EAAE;AAC9D,eAAe,cAAc,EAAE,eAAe,EAAE,gBAAgB,EAAE;AAClE,gBAAgB,gBAAgB,EAAE,WAAW,EAAE,eAAe,EAAE;AAChE,kBAAkB,gBAAgB,EAAE,eAAe,EAAE,WAAW,EAAE,gBAAgB,EAAE;;AAEpF,kBAAkB;AAClB;EACE,SAAO;EACP,aAAa;EACb,wBAAwB;EACxB,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,MAAM,EAAE,OAAO,EAAE,QAAQ;EACzB,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,2BAA2B;AAC7B;;AAEA,sBAAsB;AACtB,cAAc,WAAW,EAAE;AAC3B,cAAc,eAAe,EAAE,gBAAgB,EAAE,mBAAmB,EAAE;;AAEtE;EACE,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,eAAe;EACf,cAAc;AAChB;;AAEA,oDAAoD;AACpD;EACE,WAAW,EAAE,yBAAyB;EACtC,kBAAkB;EAClB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,aAAa;EACb,oBAAoB;EACpB,sBAAsB,EAAE,sBAAsB;AAChD;;AAEA;EACE,qBAAqB;EACrB,6CAA6C;AAC/C;;AAEA,qBAAqB,qBAAqB,EAAE,mBAAmB,EAAE;;AAEjE,WAAW;AACX;EACE,gBAAgB;EAChB,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,YAAY;EACZ,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,oEAAoE;EACpE;IACE,yBAAyB,EAAE,yCAAyC;IACpE,UAAU;IACV,gBAAgB;IAChB,aAAa;IACb,uBAAuB;EACzB;AACF;EACE,kBAAkB;EAClB,SAAS,EAAE,OAAO,EAAE,QAAQ;EAC5B,WAAW;EACX,mBAAmB;AACrB;AACA,cAAc,eAAe,EAAE,gBAAgB,EAAE,gBAAgB,EAAE,mBAAmB,EAAE;;AAExF;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;EACT,kBAAkB;AACpB;AACA,WAAW;AACX;EACE,aAAa;EACb,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,iBAAiB;AACnB;AACA;EACE,mBAAmB;EACnB,WAAW;AACb;;EAEE;IACE,sBAAsB;IACtB,gBAAgB,EAAE,8CAA8C;IAChE,6BAA6B,EAAE,kCAAkC;IACjE,MAAM;IACN,gBAAgB;EAClB;;EAEA,iDAAiD;EACjD;IACE,WAAW;IACX,yBAAyB,EAAE,qCAAqC;IAChE,YAAY;IACZ,aAAa;EACf;;EAEA;IACE,iBAAiB,EAAE,sCAAsC;EAC3D;;EAEA,4DAA4D;EAC5D;IACE,yCAAyC;IACzC,UAAU;EACZ;;EAEA;IACE,iBAAiB;EACnB;;EAEA,uCAAuC;EACvC;IACE,sBAAsB;IACtB,SAAS;EACX;;EAEA;IACE,WAAW,EAAE,+CAA+C;EAC9D;EACA;IACE,eAAe;IACf,aAAa;IACb,YAAY;EACd;EACA,oBAAoB;EACpB;IACE,8BAA8B;IAC9B,SAAS;IACT,yBAAyB;IACzB,eAAe;EACjB;;EAEA;IACE,WAAW;IACX,aAAa;IACb,8BAA8B;IAC9B,SAAS;EACX;;EAEA;IACE,SAAO,EAAE,+BAA+B;IACxC,kBAAkB;IAClB,uBAAuB;EACzB;AACF;;AAEA,uCAAuC;AACvC;EACE;IACE,UAAU;EACZ;;EAEA;IACE,eAAe;EACjB;AACF;;;;;;AAMA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,iBAAiB;AACnB;;AAEA,mBAAmB;AACnB;EACE,aAAa;EACb,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,SAAO;EACP,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,WAAW;AACb;;AAEA,+CAA+C;AAC/C;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;EACT,yBAAyB,EAAE,qBAAqB;EAChD,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,4BAA4B;AAC5B;EACE,gBAAgB,EAAE,uBAAuB;EACzC,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA,yBAAyB;AACzB;EACE,kBAAkB;EAClB,iBAAiB;EACjB,yBAAyB;EACzB,mBAAmB;EACnB,WAAW;EACX,gBAAgB;EAChB,eAAe;AACjB;;AAEA,2BAA2B;AAC3B;EACE,kBAAkB;EAClB,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,2BAA2B;AAC7B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,eAAe;EACf,cAAc;EACd,mBAAmB;EACnB,iBAAiB;EACjB,kBAAkB;EAClB,0BAA0B;AAC5B;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA,+BAA+B;AAC/B;EACE;IACE,sBAAsB;EACxB;EACA;IACE,sBAAsB;IACtB,SAAS;IACT,qBAAqB,EAAE,sCAAsC;EAC/D;AACF;;;;;;;AAOA,kCAAkC;AAClC;EACE,6DAA6D;EAC7D,aAAa;EACb,4BAA4B;EAC5B,YAAY;EACZ,iBAAiB;EACjB,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,2CAA2C;EAC3C,2CAA2C;AAC7C;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,oDAAoD;EACpD,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,4CAA4C;AAC9C;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,iDAAiD;EACjD,6BAA6B;EAC7B,oCAAoC;AACtC;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,eAAe;AACjB;;AAEA,yBAAyB;AACzB;EACE,mBAAmB;EACnB,mBAAmB;EACnB,4BAA4B;EAC5B,gBAAgB;EAChB,iBAAiB;EACjB,aAAa;EACb,sBAAsB;EACtB,gDAAgD;AAClD;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA,sBAAsB;AACtB;EACE,mBAAmB;EACnB,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,mBAAmB;EACnB,eAAe;EACf,yBAAyB;EACzB,aAAa;AACf;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;EACnB,6CAA6C;AAC/C;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,cAAc;EACd,eAAe;EACf,eAAe;AACjB;;AAEA,wBAAwB;AACxB;EACE,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,cAAc;EACd,gBAAgB;EAChB,eAAe;EACf,sBAAsB;AACxB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,8CAA8C;AAChD;;AAEA;EACE,mBAAmB;EACnB,2BAA2B;EAC3B,8CAA8C;AAChD;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA,mBAAmB;AACnB;EACE,eAAe;EACf,QAAQ;EACR,iCAAiC;EACjC,0BAA0B;EAC1B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,2BAA2B;AAC7B;;AAEA;EACE,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,UAAU;EACV,gBAAgB;EAChB,uCAAuC;AACzC;;AAEA;EACE,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;AACjB;;AAEA,yBAAyB;AACzB;EACE;IACE,sBAAsB;IACtB,aAAa;EACf;;EAEA;IACE,WAAW;IACX,gBAAgB;IAChB,4BAA4B;IAC5B,gBAAgB;IAChB,aAAa;EACf;;EAEA;IACE,WAAW;IACX,gBAAgB;IAChB,aAAa;IACb,4BAA4B;IAC5B,YAAY;EACd;AACF;;AAEA;EACE,OAAO,UAAU,EAAE,sBAAsB,EAAE;EAC3C,KAAK,UAAU,EAAE,mBAAmB,EAAE;AACxC;;;;;;;;AAQA;EACE,uBAAuB;EACvB;IACE,yBAAyB;IACzB,aAAa;IACb,uBAAuB;IACvB,cAAc,EAAE,+DAA+D;EACjF;;EAEA;IACE,sBAAsB;IACtB,gBAAgB;IAChB,6BAA6B;IAC7B,iBAAiB;;EAEnB;;EAEA,4BAA4B;EAC5B;IACE,WAAW;IACX,6BAA6B;IAC7B,4BAA4B,EAAE,uBAAuB;IACrD,YAAY;IACZ,uBAAuB,EAAE,gCAAgC;EAC3D;;EAEA;IACE,mDAAmD;IACnD,kBAAkB;IAClB,WAAW;EACb;;EAEA;IACE,eAAe;IACf,kBAAkB;IAClB,oBAAoB;IACpB,yCAAyC;EAC3C;;EAEA,qBAAqB;EACrB;IACE,WAAW;IACX,aAAa;IACb,6BAA6B;EAC/B;;EAEA;IACE,eAAe;IACf,gBAAgB;IAChB,mBAAmB;IACnB,kBAAkB;EACpB;;EAEA,WAAW;EACX;IACE,aAAa;IACb,eAAe,EAAE,6BAA6B;EAChD;;EAEA,oCAAoC;EACpC;IACE,eAAe;IACf,aAAa;IACb,sBAAsB;IACtB,kBAAkB,EAAE,0CAA0C;IAC9D,mBAAmB,EAAE,0BAA0B;EACjD;;EAEA;IACE,aAAa;IACb,sBAAsB;IACtB,oBAAoB;IACpB,WAAW;EACb;;EAEA;IACE,WAAW,EAAE,yBAAyB;IACtC,aAAa;IACb,eAAe;IACf,aAAa;IACb,uBAAuB;IACvB,mBAAmB;EACrB;;EAEA;IACE,kBAAkB;IAClB,QAAQ;IACR,OAAO;IACP,aAAa;IACb,eAAe;IACf,WAAW;IACX,gBAAgB;EAClB;;EAEA,0CAA0C;EAC1C;IACE,aAAa;EACf;AACF;;;;;;;AAOA,8EAA8E;AAC9E;EACE,2BAA2B;EAC3B;IACE,yBAAyB,EAAE,6BAA6B;IACxD,UAAU;IACV,cAAc,EAAE,mCAAmC;IACnD,kBAAkB;EACpB;;EAEA;IACE,WAAW;IACX,gBAAgB;IAChB,aAAa;IACb,sBAAsB;IACtB,gBAAgB;IAChB,mBAAmB;IACnB,uBAAuB;EACzB;;EAEA,4CAA4C;EAC5C;IACE,WAAW;IACX,uBAAuB;IACvB,uBAAuB;IACvB,YAAY;EACd;;EAEA;IACE,uBAAuB,EAAE,iCAAiC;IAC1D,mBAAmB;EACrB;;EAEA;IACE,kBAAkB;IAClB,eAAe;IACf,WAAW;IACX,yBAAyB;IACzB,yCAAyC;IACzC,gBAAgB;EAClB;;EAEA,8BAA8B;EAC9B;IACE,aAAa;IACb,UAAU,EAAE,iCAAiC;EAC/C;;EAEA;IACE,eAAe;IACf,mBAAmB;IACnB,kBAAkB;IAClB,cAAc;EAChB;;EAEA;IACE,gBAAgB;IAChB,WAAW;EACb;;EAEA,4CAA4C;EAC5C;IACE,mBAAmB;QACf,kBAAkB;;EAExB;;EAEA;IACE,YAAY,EAAE,uCAAuC;IACrD,0BAA0B,EAAE,0DAA0D;IACtF,mBAAmB;IACnB,eAAe;EACjB;;EAEA,oCAAoC;EACpC;IACE,sBAAsB;IACtB,SAAS;IACT,gBAAgB;EAClB;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,YAAY;IACZ,eAAe;IACf,mBAAmB;IACnB,UAAU;EACZ;;EAEA,wCAAwC;EACxC;IACE,aAAa;IACb,mBAAmB;IACnB,gBAAgB,EAAE,0CAA0C;IAC5D,SAAS;IACT,gBAAgB;IAChB,sCAAsC;IACtC,iCAAiC,EAAE,2BAA2B;IAC9D,SAAS;EACX;;EAEA;IACE,WAAW;IACX,8BAA8B,EAAE,8BAA8B;IAC9D,SAAS;EACX;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,eAAe;IACf,gBAAgB;IAChB,mBAAmB;IACnB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,QAAQ,EAAE,wBAAwB;EACpC;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,uBAAuB;IACvB,yBAAyB;IACzB,WAAW;IACX,QAAQ,EAAE,wBAAwB;EACpC;;EAEA,4BAA4B;EAC5B;IACE,gBAAgB;IAChB,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;IACf,WAAW;IACX,QAAQ;EACV;;EAEA,wCAAwC;EACxC;IACE,wBAAwB;EAC1B;AACF;;AAEA,yCAAyC;AACzC;EACE;IACE,wDAAwD;EAC1D;AACF","sourcesContent":["Базовые настройки\n.page-wrapper {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  min-height: 100vh;\n  background-color: #f0f4f0;\n  padding: 15px;\n  font-family: 'Montserrat', sans-serif;\n}\n\n.form-container {\n  display: flex;\n  width: 100%;\n  max-width: 1000px;\n  min-height: 600px; /* Фиксированная высота для десктопа */\n  background: white;\n  border-radius: 20px;\n  overflow: hidden;\n  box-shadow: 0 20px 40px rgba(0,0,0,0.05);\n}\n.step-container{\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n}\n/* Левая панель */\n.sidebar {\n  width: 320px;\n  background-color: #becdef;\n  padding: 40px;\n  display: flex;\n  flex-direction: column;\n  border-right: 1px solid #e0e0e0;\n}\n\n.sidebar-top {\n  display: flex;\n  align-items: center;\n  gap: 15px;\n  margin-bottom: 30px;\n}\n\n.logo-circle {\n  width: 45px;\n  height: 45px;\n  background: black;\n  color: #2563eb;\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-weight: 700;\n  font-size: 24px;\n}\n\n.brand-name { font-weight: 700; font-size: 16px; float: left; }\n.brand-phone { color: #2563eb; font-size: 13px; font-weight: 600; }\n.sidebar-text { line-height: 1.6; color: #333; font-size: 14px; }\n.sidebar-footer { margin-top: auto; font-size: 12px; color: #888; line-height: 1.4; }\n\n/* Правая панель */\n.main-content {\n  flex: 1;\n  padding: 50px;\n  /* position: relative; */\n  display: flex;\n  flex-direction: column;\n}\n\n.progress-bar {\n  position: absolute;\n  top: 0; left: 0; right: 0;\n  height: 5px;\n  background: #f0f0f0;\n}\n\n.progress-fill {\n  height: 100%;\n  background: #1aa053;\n  transition: width 0.4s ease;\n}\n\n/* Стили полей ввода */\n.form-inner { width: 100%; }\n.form-title { font-size: 24px; font-weight: 600; margin-bottom: 35px; }\n\n.input-group {\n  margin-bottom: 25px;\n  width: 100%;\n}\n\n.input-group label {\n  display: block;\n  margin-bottom: 10px;\n  font-size: 14px;\n  color: #1c1c1c;\n}\n\n/* ЧТОБЫ СТИЛИ ПРИМЕНЯЛИСЬ: используйте этот класс */\n.input-field {\n  width: 100%; /* Делает инпут длинным */\n  padding: 16px 20px;\n  border: 1px solid #e0e0e0;\n  border-radius: 8px;\n  font-size: 15px;\n  outline: none;\n  transition: all 0.2s;\n  box-sizing: border-box; /* Важно для padding */\n}\n\n.input-field:focus {\n  border-color: #1aa053;\n  box-shadow: 0 0 0 3px rgba(26, 160, 83, 0.05);\n}\n\n.input-field.error { border-color: #ff4d4d; background: #fff8f8; }\n\n/* Кнопки */\n.form-footer {\n  margin-top: auto;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding-top: 30px;\n}\n\n.btn-next {\n  background: #2563eb;\n  color: white;\n  padding: 12px 30px;\n  border-radius: 8px;\n  border: none;\n  font-weight: 600;\n  cursor: pointer;\n}\n\n.back-btn-sq {\n  width: 45px;\n  height: 45px;\n  border: 1px solid #e0e0e0;\n  background: white;\n  border-radius: 8px;\n  cursor: pointer;\n}\n\n@media (max-width: 768px) {\n  /* Делаем общий фон страницы и контейнера одним цветом для слияния */\n  .page-wrapper {\n    background-color: #f4f7f4; /* Светло-зеленоватый фон как на макете */\n    padding: 0;\n    min-height: auto;\n    display: flex;\n    justify-content: center;\n  }\n.progress-bar {\n  position: absolute;\n  top: 20px; left: 0; right: 0;\n  height: 5px;\n  background: #f0f0f0;\n}\n.form-title { font-size: 24px; margin-top: 20px; font-weight: 600; margin-bottom: 25px; }\n\n.sidebar-top {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 15px;\n  margin-bottom: 0px;\n}\n/* Кнопки */\n.form-footer {\n  margin-top: 0;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding-top: 30px;\n}\n.input-group {\n  margin-bottom: 15px;\n  width: 100%;\n}\n\n  .form-container {\n    flex-direction: column;\n    box-shadow: none; /* Убираем тень, чтобы блок сливался с фоном */\n    background-color: transparent; /* Прозрачный фон для контейнера */\n    gap: 0;\n    max-width: 350px;\n  }\n\n  /* Объединяем боковую панель и основной контент */\n  .sidebar, .main-content {\n    width: 100%;\n    background-color: #f4f7f4; /* Тот же цвет, что и у всего блока */\n    border: none;\n    padding: 20px;\n  }\n\n  .sidebar {\n    padding-bottom: 0; /* Уменьшаем отступ снизу у сайдбара */\n  }\n\n  /* Делаем разделительную линию очень тонкой или убираем её */\n  .sidebar-content {\n    border-bottom: 0px dashed rgba(0,0,0,0.1);\n    padding: 0;\n  }\n\n  .main-content {\n    padding-top: 10px;\n  }\n\n  /* Адаптация кнопок загрузки (Step 2) */\n  .upload-container-main {\n    flex-direction: column;\n    gap: 15px;\n  }\n\n  .btn-upload-action {\n    width: 100%; /* Кнопки загрузки на всю ширину для удобства */\n  }\n  .form-inner {\n    padding: 10px 0;\n    min-height: 0;\n    height: auto;\n  }\n  /* Навигация внизу */\n  .form-footer-right {\n    flex-direction: column-reverse;\n    gap: 20px;\n    background-color: #f4f7f4;\n    padding: 20px 0;\n  }\n\n  .nav-buttons-group {\n    width: 100%;\n    display: flex;\n    justify-content: space-between;\n    gap: 10px;\n  }\n\n  .btn-back-white, .btn-next-main {\n    flex: 1; /* Кнопки делят место поровну */\n    text-align: center;\n    justify-content: center;\n  }\n}\n\n/* Совсем маленькие экраны (телефоны) */\n@media (max-width: 480px) {\n  .page-wrapper {\n    padding: 0;\n  }\n  \n  .form-inner {\n    padding: 10px 0;\n  }\n}\n\n\n\n\n\n.form-inner {\n  display: flex;\n  flex-direction: column;\n  height: 100%;\n  min-height: 350px; \n}\n\n/* Сетка загрузки */\n.upload-container-main {\n  display: flex;\n  gap: 20px;\n  margin-top: 20px;\n}\n\n.upload-item-box {\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n}\n\n.upload-label {\n  font-size: 14px;\n  font-weight: 600;\n  color: #333;\n}\n\n/* Кнопка \"📥 Загрузить\" как на втором скрине */\n.btn-upload-action {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 10px;\n  background-color: #2563eb; /* Глубокий зеленый */\n  color: white;\n  padding: 14px;\n  border-radius: 10px;\n  cursor: pointer;\n  font-weight: 600;\n  font-size: 15px;\n  transition: 0.2s;\n}\n\n.btn-upload-action:hover {\n  background-color: #244faa;\n}\n\n/* Нижняя панель навигации */\n.form-footer-right {\n  margin-top: auto; /* Толкает футер вниз */\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding-top: 30px;\n}\n\n.nav-buttons-group {\n  display: flex;\n  gap: 15px;\n}\n\n/* Кнопка Назад (белая) */\n.btn-back-white {\n  padding: 12px 25px;\n  background: white;\n  border: 1px solid #e0e0e0;\n  border-radius: 12px;\n  color: #444;\n  font-weight: 500;\n  cursor: pointer;\n}\n\n/* Кнопка Далее (зеленая) */\n.btn-next-main {\n  padding: 12px 30px;\n  background-color: #2563eb;\n  color: white;\n  border: none;\n  border-radius: 8px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: background 0.2s;\n}\n\n.btn-next-main:hover {\n  background-color: #2563eb;;\n}\n\n.file-ready-badge {\n  font-size: 12px;\n  color: #2563eb;\n  background: #b5cbf9;\n  padding: 8px 12px;\n  border-radius: 6px;\n  border: 1px dashed #2563eb;\n}\n\n.error-hint {\n  color: #d32f2f;\n  font-size: 12px;\n  font-weight: 500;\n}\n\n/* Адаптивность для мобильных */\n@media (max-width: 600px) {\n  .upload-container-main {\n    flex-direction: column;\n  }\n  .form-footer-right {\n    flex-direction: column;\n    gap: 20px;\n    align-items: flex-end; /* Кнопки всё равно останутся справа */\n  }\n}\n\n\n\n\n\n\n/* Левая информационная карточка */\n.left-card {\n  background: linear-gradient(135deg, #1e293b 0%, #0f172a 100%);\n  padding: 40px;\n  border-radius: 24px 0 0 24px;\n  width: 350px;\n  min-height: 500px;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  border: 1px solid rgba(255, 255, 255, 0.05);\n  box-shadow: -10px 0 30px rgba(0, 0, 0, 0.2);\n}\n\n.left-logo .logo-circle {\n  width: 60px;\n  height: 60px;\n  background: linear-gradient(45deg, #42b693, #60e9bf);\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  margin-bottom: 24px;\n  box-shadow: 0 0 20px rgba(66, 182, 147, 0.4);\n}\n\n.logo-text {\n  font-size: 28px;\n  font-weight: 800;\n  color: #0f172a;\n}\n\n.left-title {\n  font-size: 28px;\n  margin-bottom: 8px;\n  background: linear-gradient(90deg, #fff, #94a3b8);\n  -webkit-background-clip: text;\n  -webkit-text-fill-color: transparent;\n}\n\n.left-phone {\n  color: #42b693;\n  font-weight: 600;\n  margin-bottom: 16px;\n}\n\n.left-desc {\n  color: #94a3b8;\n  line-height: 1.6;\n  font-size: 15px;\n}\n\n/* Правый блок с формой */\n.right-block {\n  background: #ffffff;\n  /* padding: 40px; */\n  border-radius: 0 24px 24px 0;\n  max-width: 450px;\n  min-height: 500px;\n  display: flex;\n  flex-direction: column;\n  /* box-shadow: 10px 0 30px rgba(0, 0, 0, 0.1); */\n}\n\n.step-title {\n  color: #0f1720;\n  font-size: 24px;\n  font-weight: 700;\n  margin-bottom: 30px;\n  text-align: center;\n}\n\n/* Стили полей ввода */\n.input-group {\n  margin-bottom: 20px;\n  display: flex;\n  flex-direction: column;\n}\n\n.input-group label {\n  font-size: 14px;\n  font-weight: 600;\n  color: #64748b;\n  margin-bottom: 8px;\n}\n\n.input-group input {\n  padding: 14px 16px;\n  border: 2px solid #f1f5f9;\n  border-radius: 12px;\n  font-size: 16px;\n  transition: all 0.3s ease;\n  outline: none;\n}\n\n.input-group input:focus {\n  border-color: #42b693;\n  background: #f8fafc;\n  box-shadow: 0 0 0 4px rgba(66, 182, 147, 0.1);\n}\n\n.input-error {\n  border-color: #ef4444 !important;\n}\n\n.error-text {\n  color: #ef4444;\n  font-size: 12px;\n  margin-top: 5px;\n}\n\n/* Кнопки и нижний ряд */\n.bottom-row {\n  margin-top: auto;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding-top: 20px;\n}\n\n.back-btn {\n  background: none;\n  border: none;\n  color: #94a3b8;\n  font-weight: 600;\n  cursor: pointer;\n  transition: color 0.3s;\n}\n\n.back-btn:hover {\n  color: #0f172a;\n}\n\n.next-btn {\n  background: #42b693;\n  color: white;\n  border: none;\n  padding: 12px 30px;\n  border-radius: 12px;\n  font-weight: 700;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  box-shadow: 0 4px 12px rgba(66, 182, 147, 0.3);\n}\n\n.next-btn:hover {\n  background: #369c7d;\n  transform: translateY(-2px);\n  box-shadow: 0 6px 15px rgba(66, 182, 147, 0.4);\n}\n\n.step-counter {\n  font-size: 14px;\n  color: #cbd5e1;\n  font-weight: 500;\n}\n\n/* Модальное окно */\n.modal-overlay {\n  position: fixed;\n  inset: 0;\n  background: rgba(15, 23, 42, 0.8);\n  backdrop-filter: blur(8px);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 1000;\n  animation: fadeIn 0.3s ease;\n}\n\n.modal-content {\n  background: white;\n  padding: 40px;\n  border-radius: 24px;\n  text-align: center;\n  width: 90%;\n  max-width: 400px;\n  box-shadow: 0 20px 50px rgba(0,0,0,0.3);\n}\n\n.modal-icon {\n  font-size: 50px;\n  margin-bottom: 20px;\n}\n\n.modal-title {\n  color: #0f172a;\n  margin-bottom: 10px;\n}\n\n.modal-message {\n  color: #64748b;\n  margin-bottom: 25px;\n}\n\n.modal-close-btn {\n  background: #0f172a;\n  color: white;\n  border: none;\n  padding: 12px 25px;\n  border-radius: 10px;\n  cursor: pointer;\n}\n\n/* --- Адаптивность --- */\n@media (max-width: 850px) {\n  .form-page {\n    flex-direction: column;\n    padding: 10px;\n  }\n  \n  .left-card {\n    width: 100%;\n    max-width: 450px;\n    border-radius: 24px 24px 0 0;\n    min-height: auto;\n    padding: 30px;\n  }\n\n  .right-block {\n    width: 100%;\n    max-width: 380px;\n    min-height: 0;\n    border-radius: 0 0 24px 24px;\n    padding: 0px;\n  }\n}\n\n@keyframes fadeIn {\n  from { opacity: 0; transform: scale(0.95); }\n  to { opacity: 1; transform: scale(1); }\n}\n\n\n\n\n\n\n\n@media (max-width: 768px) {\n  /* Общий фон страницы */\n  .page-wrapper {\n    background-color: #f4f7f4;\n    padding: 10px;\n    /* min-height: 100vh; */\n    display: block; /* Снимаем центрирование flex для более естественного скролла */\n  }\n\n  .form-container {\n    flex-direction: column;\n    box-shadow: none;\n    background-color: transparent;\n    min-height: 400PX;\n    \n  }\n\n  /* Верхняя часть (Сайдбар) */\n  .sidebar {\n    width: 100%;\n    background-color: transparent;\n    padding: 20px 10px 10px 10px; /* Аккуратные отступы */\n    border: none;\n    align-items: flex-start; /* Выравнивание по левому краю */\n  }\n\n  .sidebar-top {\n    /* justify-content: flex-start; Лого не по центру */\n    margin-bottom: 0px;\n    width: 100%;\n  }\n\n  .sidebar-text {\n    font-size: 14px;\n    text-align: center;\n    padding-bottom: 15px;\n    border-bottom: 1px dashed rgba(0,0,0,0.1);\n  }\n\n  /* Основной контент */\n  .main-content {\n    width: 100%;\n    padding: 10px;\n    background-color: transparent;\n  }\n\n  .form-title {\n    font-size: 22px;\n    margin-top: 10px;\n    margin-bottom: 25px;\n    text-align: center;\n  }\n\n  /* Инпуты */\n  .input-field {\n    padding: 14px;\n    font-size: 16px; /* Предотвращает зум на iOS */\n  }\n\n  /* Нижняя панель с кнопкой и шагом */\n  .form-footer-right {\n    margin-top: 3px;\n    display: flex;\n    flex-direction: column;\n    position: relative; /* Для абсолютного позиционирования шага */\n    padding-bottom: 4px; /* Место для текста шага */\n  }\n\n  .nav-buttons-group {\n    display: flex;\n    flex-direction: column;\n    justify-self: center;\n    width: 100%;\n  }\n\n  .btn-next-main {\n    width: 100%; /* Кнопка на всю ширину */\n    padding: 16px;\n    font-size: 16px;\n    display: flex;\n    justify-content: center;\n    border-radius: 12px;\n  }\n\n  .step-text {\n    position: absolute;\n    right: 0;\n    left: 0;\n    bottom: -18px;\n    font-size: 13px;\n    color: #888;\n    font-weight: 600;\n  }\n\n  /* Убираем лишние элементы если они есть */\n  .sidebar-footer, .progress-bar {\n    display: none;\n  }\n}\n\n\n\n\n\n\n/* --- Специальная адаптация для смартфонов (iPhone 11, 14 Pro, Android) --- */\n@media (max-width: 480px) {\n  /* 1. Общий фон и отступы */\n  .page-wrapper {\n    background-color: #f4f7f4; /* Светлый фон как в макете */\n    padding: 0;\n    display: block; /* Скролл становится естественным */\n    overflow-x: hidden;\n  }\n\n  .form-container {\n    width: 100%;\n    min-height: auto;\n    display: flex;\n    flex-direction: column;\n    box-shadow: none;\n    padding-right: 12px;\n    background: transparent;\n  }\n\n  /* 2. Верхняя часть (Логотип и информация) */\n  .sidebar {\n    width: 100%;\n    padding: 25px 20px 10px;\n    background: transparent;\n    border: none;\n  }\n\n  .sidebar-top {\n    justify-content: center; /* Лого по центру для мобильных */\n    margin-bottom: 15px;\n  }\n\n  .sidebar-text {\n    text-align: center;\n    font-size: 13px;\n    color: #555;\n    padding: 0 10px 11px 20px;\n    border-bottom: 1px dashed rgba(0,0,0,0.1);\n    line-height: 1.4;\n  }\n\n  /* 3. Основная область формы */\n  .main-content {\n    padding: 10px;\n    flex: none; /* Даем контенту расти свободно */\n  }\n\n  .form-title {\n    font-size: 20px;\n    margin: 10px 0 25px;\n    text-align: center;\n    color: #1a1a1a;\n  }\n\n  .form-inner {\n    min-height: auto;\n    width: 100%;\n  }\n\n  /* 4. Поля ввода - делаем \"Touch Friendly\" */\n  .input-group {\n    margin-bottom: 20px;\n        align-self: center;\n\n  }\n\n  .input-field, .input-group input {\n    height: 56px; /* Высокий инпут для удобства нажатия */\n    font-size: 16px !important; /* ВАЖНО: 16px предотвращает авто-зум в Safari на iPhone */\n    border-radius: 12px;\n    padding: 0 16px;\n  }\n\n  /* 5. Загрузка документов (Step 2) */\n  .upload-container-main {\n    flex-direction: column;\n    gap: 15px;\n    margin-top: 10px;\n  }\n\n  .upload-item-box {\n    width: 100%;\n  }\n\n  .btn-upload-action {\n    height: 24px;\n    font-size: 16px;\n    border-radius: 12px;\n    width: 90%;\n  }\n\n  /* 6. Нижняя панель навигации (Кнопки) */\n  .form-footer-right, .form-footer, .bottom-row {\n    padding: 20px;\n    background: #f4f7f4;\n    position: sticky; /* Кнопки всегда \"под рукой\" при скролле */\n    bottom: 0;\n    margin-top: 20px;\n    border-top: 1px solid rgba(0,0,0,0.05);\n    flex-direction: column !important; /* Кнопки друг под другом */\n    gap: 12px;\n  }\n\n  .nav-buttons-group {\n    width: 100%;\n    flex-direction: column-reverse; /* Назад внизу, Далее вверху */\n    gap: 10px;\n  }\n\n  .btn-next-main, .next-btn, .btn-next {\n    width: 100%;\n    height: 56px;\n    font-size: 17px;\n    font-weight: 700;\n    border-radius: 14px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    order: 1; /* Кнопка \"Далее\" выше */\n  }\n\n  .btn-back-white, .back-btn, .back-btn-sq {\n    width: 100%;\n    height: 50px;\n    background: transparent;\n    border: 1px solid #d0d0d0;\n    color: #777;\n    order: 2; /* Кнопка \"Назад\" ниже */\n  }\n\n  /* 7. Текст шагов (1 из 2) */\n  .step-counter, .step-text {\n    position: static;\n    text-align: center;\n    margin-top: 10px;\n    font-size: 12px;\n    color: #aaa;\n    order: 3;\n  }\n\n  /* Прячем лишние декоративные элементы */\n  .progress-bar, .sidebar-footer, .sidebar-bottom {\n    display: none !important;\n  }\n}\n\n/* Фикс для iPhone с челкой (Safe Area) */\n@supports (padding: env(safe-area-inset-bottom)) {\n  .form-footer-right, .form-footer {\n    padding-bottom: calc(20px + env(safe-area-inset-bottom));\n  }\n}\n\n\n\n\n\n\n\n\n\n\n\n\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
